import { HeaderToggle, NewsCard } from '@components';
import { Button, Container, Typography } from '@design-system';
import { NewsSkeleton } from '@pages';
import { AnimatePresence, motion } from 'framer-motion';
import { MdDoneAll } from 'react-icons/md';
import './NewsPage.scss';
import { useNewsPageVM } from './useNewsPageVM';

export const NewsPage: React.FC = () => {
    const {
        news,
        unreadNews,
        unreadCount,
        isLoading,
        isMarkingAllAsSeen,
        selectedNews,
        handleSelectNews,
        handleMarkAllAsRead
    } = useNewsPageVM();

    const unreadLabel = unreadCount > 0 ? `Non lues (${unreadCount})` : 'Non lues';

    return (
        <div className="news-page">
            <Container padding="none">
                <HeaderToggle labels={['Toutes', unreadLabel]}>
                    <Container>
                        {isLoading && <NewsSkeleton />}
                        {!isLoading && news.map((item) => (
                            <NewsCard key={item.id} news={item} callback={() => handleSelectNews(item)} />
                        ))}
                    </Container>
                    <Container>
                        {isLoading && <NewsSkeleton />}
                        {!isLoading && unreadNews.length === 0 && (
                            <Typography intrinsic="p" color="marine">
                                Vous avez lu toutes les actualités.
                            </Typography>
                        )}
                        {!isLoading && unreadNews.length > 0 && (
                            <>
                                <div className="news-mark-all-read-wrapper">
                                    <Button
                                        color="green"
                                        variant="secondary"
                                        size="small"
                                        icon={<MdDoneAll />}
                                        onClick={handleMarkAllAsRead}
                                        disabled={isMarkingAllAsSeen}
                                    >
                                        Tout marquer comme lu
                                    </Button>
                                </div>
                                {unreadNews.map((item) => (
                                    <NewsCard key={item.id} news={item} callback={() => handleSelectNews(item)} />
                                ))}
                            </>
                        )}
                    </Container>
                </HeaderToggle>
            </Container>

            <AnimatePresence>
                {selectedNews && (
                    <div className="news-card-detail">
                        <motion.div
                            className="news-card-overlay"
                            initial={{ opacity: 0 }}
                            animate={{ opacity: 1 }}
                            exit={{ opacity: 0 }}
                            onClick={() => handleSelectNews(null)}
                        />

                        <motion.div
                            className="news-card-container"
                            initial={{ y: 500 }}
                            animate={{ y: 0 }}
                            exit={{ y: 800 }}
                            transition={{ type: 'spring', stiffness: 300, damping: 30, duration: 0.2 }}
                            drag="y"
                            dragConstraints={{ top: 0, bottom: 0 }}
                            dragElastic={{ top: 0, bottom: 0.5 }}
                            onDragEnd={(_, { offset }) => {
                                if (offset.y > 100) {
                                    handleSelectNews(null);
                                }
                            }}
                        >
                            <div className="news-card-drag-handle" />
                            <NewsCard news={selectedNews} detailed />
                        </motion.div>
                    </div>
                )}
            </AnimatePresence>
        </div>
    );
};
